import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { Session } from '../interfaces';
import { DispatchDateRoute, DispatchDate, DispatchDateFilter } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DispatchDateService {
  constructor(private apiService: ApiService) {}

  read(): Observable<DispatchDate[]> {
    let session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (session && session.dispatchDates) {
      return of(session.dispatchDates);
    } else {
      return this.apiService.get(this.apiService.dispatchDates).pipe(
        map((dispatchDates: DispatchDate[]) => {
          session = JSON.parse(localStorage.getItem(environment.sessionAuth));
          session.dispatchDates = dispatchDates;
          localStorage.setItem(
            environment.sessionAuth,
            JSON.stringify(session)
          );
          return dispatchDates;
        })
      );
    }
  }

  getRoutesByDate(dispatchDateFilters: DispatchDateFilter): Observable<DispatchDateRoute[]> {
    return this.apiService.post(this.apiService.dispatchDates, dispatchDateFilters);
  }

  update(data: any): Observable<DispatchDateRoute> {
    return this.apiService.put(this.apiService.dispatchDates, data).pipe(
      map(response => {
        this.removeSession();
        return response;
      })
    );
  }

  removeSession() {
    const session: Session = JSON.parse(
      localStorage.getItem(environment.sessionAuth)
    );
    if (session.dispatchDates) {
      delete session.dispatchDates;
      localStorage.setItem(environment.sessionAuth, JSON.stringify(session));
    }
  }
}
